/* stylelint-disable */
:host {
  display: inline-block;
}

.icon {
  display: flex;
  opacity: 0;
  pointer-events: none;
}

.icon--loaded {
  opacity: 1;
}

.icon__element {
  pointer-events: none;
}

.icon--nano {
  width: 14px;
  height: 14px;
  font-size: 14px;
  line-height: 14px;
}

.icon--micro {
  width: 18px;
  height: 18px;
  font-size: 18px;
  line-height: 18px;
}

.icon--small {
  width: 24px;
  height: 24px;
  font-size: 24px;
  line-height: 24px;
}

.icon--medium {
  width: 32px;
  height: 32px;
  font-size: 32px;
  line-height: 32px;
}

.icon--large {
  width: 52px;
  height: 52px;
  font-size: 52px;
  line-height: 52px;
}

.icon--xlarge {
  width: 62px;
  height: 62px;
  font-size: 62px;
  line-height: 62px;
}